<template>
  <div class="product-detail-page">
    <div v-loading="loading">
      <!-- 页面标题区域 -->
      <div class="page-header">
        <div class="header-bg"></div>
        <div class="container">
          <div class="breadcrumb">
            <span @click="navigateToHome" class="breadcrumb-link">{{ $t('products.detail.breadcrumbHome') }}</span>
            <span class="separator"> > </span>
            <span class="breadcrumb-link"  @click="navigateToProducts">{{ $t('products.detail.breadcrumbCenter') }}</span>
            <span class="separator"> > </span>
            <span
              v-if="breadcrumb.parentName"
              class="breadcrumb-link"
            >
              {{ breadcrumb.parentName }}
            </span>
            <span class="separator"> > </span>
            <span class="current">{{ breadcrumb.productName }}</span>
          </div>

          <!-- 产品基本信息 -->
          <div class="product-info" v-loading="briefLoading">
            <div class="product-gallery">
              <!-- 主图展示 -->
              <div class="main-image">
                <img v-if="briefInfo.images.length" v-lazy="briefInfo.images[currentImageIndex]+ '?x-oss-process=image/resize,w_492'" :alt="briefInfo.name">
                <img v-else src="../../assets/imgError.jpg" :alt="briefInfo.name">
              </div>
            </div>
            <div class="product-rt">
              <template v-if="briefInfo.category && briefInfo.category === 1">
                <biology :brief-info="briefInfo" @productInquiry="productInquiry" @purchase="purchase" @productModel="productModel"></biology>
              </template>
              <template v-else>
                <chemistry :brief-info="briefInfo" @productInquiry="productInquiry" @purchase="purchase" @productModel="productModel"></chemistry>
              </template>
            </div>
          </div>
        </div>
      </div>


      <!-- 产品详情内容 -->
      <section class="detail-section">
        <div class="container">
          <!-- 产品详细信息 -->
          <div class="detail-tabs">
            <div class="detail-lf">

              <!-- 内容区域 -->
              <div class="detail-content">
                <template v-for="(products, productIndex) in product">
                  <!-- format 为 1 纯文本-->
                  <div v-if="products.format === '1'" :id="products.id" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{products.name}}</h2>
                    </div>
                    <div class="description-content">
                      <div class="section">
                        <p>{{ products.content }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 2 表格-->
                  <div :id="products.id" v-if="products.format === '2' && briefInfo.category !== 1"  class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{products.name}}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="section">
                        <div class="specs-wrapper">
                          <div class="specs-left" v-for="(item,  index) in products.content" :key="index + item.label">
                            <div class="specs-title">{{ item.label }}</div>
                            <div class="specs-list">
                              <div class="specs-item" v-for="(lxh, index) in item.children" :key="index + lxh.label" v-if="lxh.value">
                                <span class="label">{{ lxh.label }}</span>
                                <span class="value">{{ lxh.value }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div :id="products.id" v-if="products.format === '2' && briefInfo.category === 1"  class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{products.name}}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="category-wrapper">
                        <div class="specs-left" v-for="(item,  index) in products.content" :key="index + item.label">
                          <div class="specs-title">{{ item.label }}</div>
                          <div class="specs-list">
                            <div class="specs-item" v-for="(lxh, index) in item.children" :key="index + lxh.label" v-if="lxh.value">
                              <span class="label" v-if="lxh.label">{{ lxh.label }}</span>
                              <span class="value">{{ lxh.value }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 3 富文本-->
                  <div :id="products.id" v-if="products.format === '3'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{products.name}}</h2>
                    </div>
                    <div class="description-content">
                      <div class="section">
                        <div class="more-intro">
                          <div v-html="products.content.content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- format 为 4 链接-->
                  <div :id="products.id" v-if="products.format === '4'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{products.name}}</h2>
                    </div>
                    <div class="documents-content">
                      <div class="doc-sections">
                        <!-- 技术文档 -->
                        <div class="doc-section" v-for="(item, index) in products.documents" :key="index" v-if="item.manus.length">
                          <div class="section-header">
                            <div class="header-bg tech-bg">{{ item.typeLabel }}</div>
                          </div>
                          <div class="doc-list">
                            <div class="doc-item" v-for="(child, i) in item.manus" :key="i + child.id">
                              <span class="doc-name">{{ child.name }}</span>
                              <div class="doc-actions">
                                <el-button v-if="item.type==='1'" class="view-btn" size="small"
                                           @click="handleDownload(child)"
                                           :disabled="!child.url">查看</el-button>
                                <el-button v-else class="view-btn" size="small"
                                           @click="toDocument(child)"
                                           :disabled="!child.content">查看</el-button>
                                <!--                              <el-button class="download-btn" type="primary" size="small">{{ $t('productDetail.buttons.download') }}</el-button>-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 5 remark-->
                  <div :id="products.id" v-if="products.format === '5'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{  $t('products.detail.notes') }}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="section bg-gry">
                        <div class="notes-wrapper">
                          <div class="notes-content">
                            <p>{{ products.notes }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- format 为 6 产品特色-->
                  <div :id="products.id" v-if="products.format === '6'" class="content-section" :ref="'format' + products.id">
                    <div class="detail-content-tit">
                      <h2 class="section-title-product">{{ $t('products.detail.features') }}</h2>
                    </div>
                    <div class="description-content ">
                      <div class="cpTs-box">
                        <div
                            class="cpts-item"
                            v-for="(item, idx) in products.content"
                            :key="idx"
                        >
                          <div class="cpts-icon">
                            <img v-lazy="item.icon + '?x-oss-process=image/resize,w_44'" :alt="item.name" />
                          </div>
                          <div class="cpts-text">
                            <div class="cpts-desc">{{ item.name }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

              <!-- format 为 7 服务优势-->
              <div :id="products.id" v-if="products.format === '7'" class="content-section" :ref="'format' + products.id">
                <div class="detail-content-tit">
                  <h2 class="section-title-product">{{ $t('products.detail.advantages') }}</h2>
                </div>
                <div class="description-content ">
                  <div>
                    <div class="fwYs-scroll">
                      <div class="fwys-item" v-for="(item, idx) in products.content" :key="idx">
                        <div class="fwys-item-box">
                          <div class="fwys-icon">
                            <img :src="item.icon + '?x-oss-process=image/resize,w_76'" :alt="item.title" />
                          </div>
                          <div class="fwys-info">
                            <div class="fwys-title">{{ item.name }}</div>
                            <div class="fwys-desc">{{ item.title }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

</template>
</div>

</div>
<!--右侧栏目 -->
<div class="detail-rt">
<!-- 定制合成入口 -->
<div class="side-block custom-entry" @click.stop="ProductCustomization">
  <h3 class="block-title">{{ $t('products.detail.customSynthesis') }}</h3>
</div>

<!-- 配套产品推荐 -->
<div class="side-block related-products" v-if="relatedProducts.length">
  <h3 class="block-title">{{ $t('products.detail.related') }}</h3>
  <div class="block-content">
    <div class="product-list">
      <div v-for="(item, index) in relatedProducts"
           :key="index"
           class="product-item"
           @click="handleProductClick(item)">
        <div class="product-name">
          <span class="name">{{ item.name }}</span>
          <span class="cas">{{ $t('products.detail.cas', { cas: item.cas }) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 优势产品推荐 -->
<div class="side-block featured-products" v-if="featuredProducts.length">
  <h3 class="block-title">{{ $t('products.detail.featured') }}</h3>
  <div class="block-content">
    <div class="product-list">
      <div v-for="(item, index) in featuredProducts"
           :key="index"
           class="product-item"
           @click="handleProductClick(item)">
        <div class="product-name">
          <span class="name">{{ item.name }}</span>
          <span class="cas">{{ $t('products.detail.cas', { cas: item.cas }) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</section>

      <!-- 底部按钮组 -->
      <div class="bottom-actions" :class="{ 'show': showBottomActions }">
        <div class="container">
          <el-button type="primary" class="inquiry-btn" @click.stop="productInquiry">
            <i class="el-icon-message"></i>
            {{ $t('products.detail.batchInquiry') }}
          </el-button>
          <el-button type="primary" class="purchase-btn" @click.stop="purchase">
            <i class="el-icon-shopping-cart-2"></i>
            {{ $t('products.detail.researchPurchase') }}
          </el-button>
          <el-button type="primary" class="sample-btn"  @click.stop="productModel">
            <i class="el-icon-box"></i>
            {{ $t('products.detail.getSample') }}
          </el-button>
        </div>
      </div>
    </div>
    <PurchaseListDialog
      :visible.sync="showPurchaseDialog"
      :list="purchaseList"
      :total="purchaseTotal"
      :page-size="purchasePageSize"
      :current-page="purchaseCurrentPage"
      @page-change="handlePurchasePageChange"
    />
  </div>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getProductDetail, getProductBrief, getProductRecommendList } from '@/api/products'
import {mapState} from "vuex";
import chemistry from './chemistry.vue'
import biology from './biology.vue'
import { getPageSearch } from '@/api'
import PurchaseListDialog from '@/components/PurchaseListDialog.vue'
import {pushWithLanguage} from "@/utils/routeUtils";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductDetail',
  components: {
    chemistry,
    biology,
    PurchaseListDialog
  },
  data() {
    return {
      loading: false,
      briefLoading: false,
      activeSection: '',
      showBottomActions: false,
      productId: null,
      navItems: [],
      searchResults: [],
      currentImageIndex: 0,
      breadcrumb: {
        parentName: '',
        categoryName: '',
        productName: ''
      },
      briefInfo: {
        name: '',
        nameOther: '',
        formula: '',
        casNo: '',
        sn: '',
        molecularWeight: '',
        images: [],
        category: 9
      },
      product: [],
      relatedProducts: [],
      featuredProducts: [],
      showPurchaseDialog: false,
      purchaseList: [],
      purchaseTotal: 0,
      purchasePageSize: 10,
      purchaseCurrentPage: 1,
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },

  watch: {
    // // 监听路由参数变化
    // '$route'(to, from) {
    //   // 如果产品 ID 发生变化
    //   if (to.params.id !== from.params.id) {
    //     // 重新获取产品信息
    //     this.fetchProductBrief(to.params.id)
    //     this.fetchProductDetail(to.params.id)
    //   }
    // },
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 加载产品数据
          this.fetchProductBrief(this.productId)
          this.fetchProductDetail(this.productId)
        }
      },
      immediate: false
    }
  },

  created() {
    const productId = this.$route.params.id
    this.productId = productId
    this.fetchProductBrief(productId)
    this.fetchProductDetail(productId)
    this.fetchRecommendProducts()
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  methods: {

    //跳转内部页面查看
    toDocument(item) {
      pushWithLanguage('/products/Document', this.currentLanguage, { Detail: JSON.stringify(item) }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    //查看文件
    handleDownload(item) {
      if (item.url) {
        window.open(item.url)
      }
    },
    // 产品定制
    ProductCustomization() {
      this.$croOrCdmo(this.briefInfo)
    },
    //获取样品
    productModel() {
      this.$service(this.briefInfo)
    },
    //工业采购询价
    productInquiry() {
      this.$chart('product', this.briefInfo)
    },
    //科研购买
    async purchase() {
      this.$loading.show()
      const productData = this.briefInfo && this.briefInfo.category === 1
        ? { enzymeName: this.briefInfo.name, type: 2 }
        : { casNo: this.briefInfo.casNo, type: 2 }
      productData.current = this.purchaseCurrentPage
      productData.size = this.purchasePageSize

      const response = await getPageSearch(productData)
      this.$loading.hide()
      if (response.success) {
        const pageData = response.data.filter(item => item.type === 2)[0]?.page || { records: [], total: 0 }
        this.purchaseList = pageData.records || []
        this.purchaseTotal = pageData.total || 0
        this.purchaseCurrentPage = pageData.current
        if (this.purchaseList.length > 0) {
          this.showPurchaseDialog = true
        } else {
          this.$purchase()
        }
      } else {
        this.$message.error(response.msg || '搜索失败')
      }
    },
    async fetchProductBrief(productId) {
      try {
        this.briefLoading = true
        const response = await getProductBrief(productId)
        if (response.success) {
          this.briefInfo = {
            ...response.data,
            images: response.data.cover ? response.data.cover.split(',') : []
          }
          this.breadcrumb.parentName = this.briefInfo.productTypeName
          this.breadcrumb.productName = this.briefInfo.name
          try {
            const metaInfo = {
              title: response.data.title || '',
              keywords: response.data.keywords || '',
              description: response.data.description || ''
            }
            this.$store.commit("CHANGE_META_INFO", metaInfo)
          } catch (e) {
            console.error('更新页面 Meta 信息失败:', e)
          }
        } else {
          this.$message.error(response.msg || '获取产品基本信息失败')
        }
      } catch (error) {
        console.error('获取产品基本信息失败:', error)
        this.$message.error('获取产品基本信息失败，请稍后重试')
      } finally {
        this.briefLoading = false
      }
    },

    async fetchProductDetail() {
      try {
        this.loading = true
        const productId = this.$route.params.id
        const query = this.$route.query
        const response = await getProductDetail(productId, query)
        
        if (response.success) {
          this.product = {
            ...response.data
          }
          // 设置导航菜单
          if (response.data && response.data.length) {
            this.navItems = response.data.map(nav => ({
              id: nav.id,
              label: nav.name
            }))
            // 设置默认激活的导航项
            this.activeSection = this.navItems[0]?.id || ''
          }
        } else {
          this.$message.error(response.msg || '获取产品详情失败')
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
        this.$message.error('获取产品详情失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleScroll() {
      const sections = this.navItems.map(item => this.$refs['format' + item.id])
      const scrollPosition = window.scrollY + 100 

      // 检查产品信息区域的按钮是否在视窗内
      const productContent = document.querySelector('.product-content')
      if (productContent) {
        const actionButtons = productContent.querySelector('.action-buttons')
        if (actionButtons) {
          const rect = actionButtons.getBoundingClientRect()
          this.showBottomActions = rect.bottom < 0
        }
      }

      // 只有在有导航项时才进行滚动检测
      if (this.navItems.length) {
        sections.forEach((section, index) => {
          if (section && section[0]) {
            const navHeight = document.querySelector('.detail-nav')?.offsetHeight || 0
            const sectionTop = section[0].offsetTop - navHeight
            const sectionBottom = sectionTop + section[0].offsetHeight
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              this.activeSection = this.navItems[index].id
            }
          }
        })
      }
    },
    async fetchRecommendProducts() {
      try {
        // 获取配套产品推荐
        const relatedRes = await getProductRecommendList({
          sourceId: this.productId || '',
          sourceType : '1'
        })
        if (relatedRes.success) {
          this.relatedProducts =relatedRes.data[0]? relatedRes.data[0].products.map(item => ({
            name: item.name,
            cas: `CAS: ${item.casNo}`,
            id: item.id
          })) : []
          this.featuredProducts = relatedRes.data[1]? relatedRes.data[1].products.map(item => ({
            name: item.name,
            cas: `CAS: ${item.casNo}`,
            id: item.id
          })) : []
        }
      } catch (error) {
        console.error('获取推荐产品失败:', error)
      }
    },
    handleProductClick(item) {
      if (item.id) {
        pushWithLanguage(`/products/${item.id}`, this.currentLanguage).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error( err)
          }
        })
      }
    },
    handlePurchasePageChange(page) {
      this.purchase(page)
    },
    getParentPath() {
      // 根据产品分类返回对应的父级路径
      if (this.briefInfo.category === 1) {
        return this.$route.path.includes('/zh/') ? '/zh/products' : '/products'
      }
      return this.$route.path.includes('/zh/') ? '/zh/products' : '/products'
    },
    navigateToHome() {
      pushWithLanguage('/', this.currentLanguage);
    },

    navigateToProducts() {
      console.log('navigateToProducts','======')
      pushWithLanguage('/products', this.currentLanguage);
    }
  },


  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
@import '../../assets/styles/mixins.less';

.product-detail-page {
  .page-header {
    padding: 175px 0 60px;
    position: relative;
    text-align: left;
    background-image: url('https://file.yacoo.com.cn/staticResource/products/products-header-bg.webp?x-oss-process=image/resize,w_1920');
    height: auto !important;

    .container {
      position: relative;
      width: 100%;
      z-index: 2;
      margin: 0 auto;
      padding: 0;
    }

    .breadcrumb {
      color: #ffffff;
      font-size: 14px;
      margin: 0 0 30px 0;
      text-align: left;

      .separator {
        margin: 0 8px;
        color: rgba(255, 255, 255, 0.7);
      }

      .current {
        color: #ffffff;

      }

      .breadcrumb-link {
        color: #ffffff;
        text-decoration: none;
        transition: opacity 0.3s ease;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
          text-decoration: underline;
        }
      }
    }

    .product-info {
      display: flex;
      flex-direction: row-reverse;
      gap: 180px;
      margin-bottom: 0;
      padding: 10px 0;
      align-items: center;
      .product-rt {
        width: calc(100% - 360px - 180px);
        padding: 0;
      }
      .product-gallery {
        width: 360px;
        height: 360px;
        position: relative;
        flex-shrink: 0;
        .main-image {
          width: 100%;
          height: 100%;
          background: #ffffff;
          border: none;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
          position: relative;
          z-index: 0;
          img {
            width: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
          }
        }
        .main-image::after {
          content: ' ';
          position: absolute;
          background-color: rgba(18 , 55 , 105 , .1) !important;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .thumbnail-list {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 15px;
          justify-content: center;

          .thumbnail-item {
            width: 70px;
            height: 70px;
            border: 2px solid transparent;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border-radius: 4px;
            transition: all 0.3s ease;

            &:hover {
              border-color: #3A5685;
              img {
                transform: scale(1.1);
              }
            }

            &.active {
              border-color: #3A5685;
              background-color: rgba(58, 86, 133, 0.05);
            }

            img {
              max-width: 90%;
              max-height: 90%;
              object-fit: contain;
              transition: transform 0.3s ease;
            }
          }
        }
      }


    }
  }

  .breadcrumb {
    color: #707070;
    font-size: 16px;
    margin: 30px 0 0 0;
    .separator {
      margin: 0 10px;
      color: #707070;
    }

    .current {
      color: #707070;
    }
  }

  .detail-section {
    padding: 40px 0 60px;
    background: #fff;

    .container {
      max-width: 1520px;
      margin: 0 auto;
      padding: 0;
    }

    .detail-tabs {
      margin-bottom: 60px;
      display: flex;
      justify-content: space-between;
      gap: 40px;
      .detail-lf{
        flex: 1;
      }
      .detail-rt{
        flex-shrink: 0;
        min-width: 200px;
        width: 385px;
      }
      .detail-nav {
        position: sticky;
        top: 0;
        z-index: 10;
        background: #F7F7F7;
        //border-bottom: 1px solid #E5E5E5;
        margin-bottom: 30px;

        .nav-items {
          display: flex;
          gap: 2px;

          .nav-item {
            padding: 15px 30px;
            font-size: 16px;
            color: #666;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
              color: #19529F;
            }

            &.active {
              color: #fff;
              background-color: #323C46;
            }
          }
        }
      }

      .detail-content {
        .content-section {
          margin-bottom: 60px;
          scroll-margin-top: 60px;
          .detail-content-tit{
            position: relative;
            width: 100%;
            display: flex;
            height: fit-content;
            .section-title-product {
              min-width: 200px;
              padding: 0 20px;
              height: 67px;
              background: linear-gradient( 336deg, #E26E76 0%, #19529F 100%);
              font-size: 24px;
              color: #FFFFFF;
              line-height: 33px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 10px;
              position: relative;
            }
            &:after {
              content: ' ';
              position: absolute;
              border: 1px solid;
              border-image: linear-gradient(270deg, rgba(226, 110, 118, 1), rgba(25, 82, 159, 1)) 1 1;
              width: 100%;
              left: 0;
              bottom: -4px;
            }
          }


        }
      }

    .description-content {
        .section {
          margin-bottom: 40px;
          padding: 30px 0;
          margin-left: 50px;
          &.bg-gry{
            background-color: #F9F9F9;
          }
          &>p{
            font-size: @font-size-note;
          }
          .specs-wrapper {
            width: 100%;
            .specs-left, .specs-right {
                width: 100%;
                display: flex;
                align-items: flex-start;
                padding: 12px 0 32px 0;
                margin-bottom: 20px;
                border-bottom: 1px solid #E4E4E4;
              &:last-child {
                border-bottom: none;
                margin-bottom: 0;
              }

              .specs-title {
                width: 200px;
                font-size: @font-size-note;
                color: #000;
                margin-bottom: 20px;
                position: relative;
                padding-left: 0;
              }

              .specs-list {
                .specs-item {
                  display: flex;
                  align-items: center;
                  padding: 0 40px;
                  margin-bottom: 20px;
                  border-radius: 2px;

                  &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                  }

                  .label {
                    width: 200px;
                    color: #666;
                    font-size: @font-size-note;
                  }

                  .value {
                    flex: 1;
                    color: #333;
                    font-size: @font-size-note;
                  }
                }
              }
            }
          }

          .category-wrapper {
            width: 100%;
            .specs-left, .specs-right {
              width: 100%;
              display: flex;
              align-items: flex-start;
              padding: 5px 0;
              margin-bottom: 10px;
              &:last-child {
                border-bottom: none;
                margin-bottom: 0;
              }

              .specs-title {
                min-width: 200px;
                font-size: @font-size-note;
                color: #000;
                margin-bottom: 20px;
                position: relative;
                padding-left: 0;
              }

              .specs-list {
                .specs-item {
                  display: flex;
                  align-items: center;
                  padding: 0 40px;
                  margin-bottom: 20px;
                  border-radius: 2px;

                  &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                  }

                  .label {
                    width: 200px;
                    color: #666;
                    font-size: @font-size-note;
                  }

                  .value {
                    flex: 1;
                    color: #333;
                    font-size: @font-size-note;
                  }
                }
              }
            }
          }

          .more-intro {
            margin-top: 20px;

            img {
              width: 100%;
              height: auto;
              object-fit: contain;
            }
          }

          .notes-wrapper {
            padding: 30px;

            .notes-content {
              background-color: #fff;
              padding: 20px 30px;
              border-radius: 2px;

              p {
                font-size: 14px;
                line-height: 1.8;
                color: #666;
                margin: 0;
                text-align: justify;
                text-indent: 2em;
              }
            }
          }
        }
      }

      .documents-content {
        background-color: #F9F9F9;
        padding: 30px;

        .doc-sections {
          .doc-section {
            margin-bottom: 30px;

            &:last-child {
              margin-bottom: 0;
            }

            .section-header {
              margin-bottom: 8px;
              display: flex;

              .header-bg {
                display: inline-block;
                padding: 8px 0;
                font-size: @font-size-note;
                color: #000000;
                line-height: 28px;
                text-align: justify;
                font-style: normal;


                &.more-bg {
                  background-color: #7290AE;
                }
              }
            }

            .doc-list {
              .doc-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 12px 30px;
                background-color: #fff;
                margin-bottom: 10px;
                border-radius: 2px;

                &:last-child {
                  margin-bottom: 0;
                }

                .doc-name {
                  font-size: 14px;
                  color: #333;
                }

                .doc-actions {
                  display: flex;
                  gap: 10px;

                  .view-btn {
                    border-color: #DCDFE6;
                    color: #666;
                  }

                  .download-btn {
                    background-color: #2B6EC8;
                    border-color: #2B6EC8;

                    &:hover {
                      opacity: 0.9;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .bottom-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    padding: 15px 0;
    z-index: 100;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    opacity: 0;
    visibility: hidden;

    &.show {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }

    .container {
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        width: fit-content;
        padding: 0 30px;
        height: 40px;
        i {
          margin-right: 5px;
        }
      }

      .inquiry-btn {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }

      .purchase-btn {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }

      .sample-btn {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
        border-color: #323C46;
        color: #000;
      }
    }
  }

  .side-block {
    background-color: #F9F9F9;
    margin-bottom: 20px;
    border-radius: 2px;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }

    .block-title {
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
      text-shadow: 0 2px 7px rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
    }

    &.featured-products , &.related-products {
      .block-title {
        background: linear-gradient( 332deg, #E26E76 0%, #19529F 100%);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5), inset 0 1px 3px 0 #C7ECFF;
        padding: 21px 0;
        text-shadow: none;
      }
    }

    .block-content {
      padding: 20px;

      .custom-btn {
        width: 100%;
        background-color: #323C46;
        border-color: #323C46;
        
        &:hover {
          opacity: 0.9;
        }
      }

      .product-list {
        .product-item {
          padding: 13px 26px;
          background: #FFFFFF;
          box-shadow: 0 2px 8px 0 rgba(0,0,0,0.19);
          margin-bottom: 10px;
          &:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }

          .product-name {
            display: flex;
            flex-direction: column;
            gap: 5px;
            cursor: pointer;

            &:hover {
              .name {
                color: #19529F;
              }
            }

            .name {
              font-size: 14px;
              color: #333;
              transition: color 0.3s ease;
            }

            .cas {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }
  .custom-entry{
    background-image: url("../../assets/images/products/dzh_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 52px 0;
    cursor: pointer;
  }
}
.cpTs-box {
  display: flex;
  flex-wrap: wrap;
  gap: 58px 46px;
  margin-left: 0;
  justify-content: flex-start;
  padding: 50px 0 80px;
}
.cpts-item {
  width: calc(100% / 2 - 46px);
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.cpts-icon {
  width: 67px;
  height: 67px;
  min-width: 56px;
  min-height: 56px;
  border-radius: 50%;
  background: linear-gradient( 319deg, #E26E76 0%, #19529F 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 26px;
  box-shadow: 0 2px 8px 0 rgba(58,86,133,0.15);
}
.cpts-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
.cpts-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cpts-title {
  font-size: 18px;
  color: #19529f;
  margin-bottom: 6px;
}
.cpts-desc {
  font-size: @font-size-note;
  color: #383838;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
@media (max-width: 900px) {
  .cpts-item {
    width: 100%;
  }
}
.fwYs-scroll {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 20px 5px 20px 5px;
  scrollbar-width: thin;
  scrollbar-color: #19529F #F9F9F9;
}
.fwys-item {
  width: 215px;
  height: 332px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 4px 0 rgba(55,59,129,0.25);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 40px;
  flex-shrink: 0;
  transition: box-shadow 0.2s;
    .fwys-item-box{
      padding: 0 13px;
      width: fit-content;
      height: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  &:hover {
    box-shadow: 0 4px 16px 0 rgba(25,82,159,0.18);
  }
}
.fwys-icon {
  width: 76px;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.fwys-title {
  font-size: 24px;
  color: #222A41;
  line-height: 32px;
  text-shadow: 0 2px 4px rgba(55,59,129,0.25);
  text-align: center;
  font-style: normal;
  margin-top: 20px;
  margin-bottom: 30px;
}
.fwys-desc {
  font-size: 16px;
  color: #6D7783;
  line-height: 28px;
  text-shadow: 0 2px 4px rgba(55,59,129,0.25);
  text-align: center;
  font-style: normal;
}
</style> 

